import Vue from 'vue'
import { URL_PAYMENTS } from '@/constants/urls.js'
import { PAYMENT_TEMPLATES_MANAGEMENT, GENERAL_FILES } from '@/constants/store.js'

const actions = {
  async [PAYMENT_TEMPLATES_MANAGEMENT.ACTIONS.GET_TEMPLATE] ({ dispatch }, model) {
    const url = `${Vue.getBusinessHost()}${URL_PAYMENTS}/${model.paymentPurposeTypesEnum}/requisites?${Vue.helpers.getQueryParamsString(model.params)}`
    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  }
}

export default {
  namespaced: true,
  actions
}
